<template>
  <section class="ProductPushCom">
    <a :href="pushComObj.pushComUrl">
      <img class="ProductPushCom-image lazyload" :data-src="pushComObj.pushCom" />
    </a>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

import "@/components/Product/ProductPushCom/ProductPushCom.scss";

export default {
  name: "ProductPushCom",
  computed: {
    ...mapGetters({ pushComObj: "getPushCom" }),
  },
};
</script>
